export const EVENT_DELETE_OPEN_MODAL = "EVENT_DELETE_OPEN_MODAL";
export const EVENT_DELETE_REQUEST = "EVENT_DELETE_REQUEST";
export const EVENT_DELETE_RESULT = "EVENT_DELETE_RESULT";